<template>
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.25 10.5H14L12.25 13.125H8.75L7 10.5H1.75"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.76875 4.47125L1.75 10.5V15.75C1.75 16.2141 1.93437 16.6592 2.26256 16.9874C2.59075 17.3156 3.03587 17.5 3.5 17.5H17.5C17.9641 17.5 18.4092 17.3156 18.7374 16.9874C19.0656 16.6592 19.25 16.2141 19.25 15.75V10.5L16.2312 4.47125C16.0864 4.17969 15.863 3.93432 15.5863 3.76274C15.3096 3.59116 14.9906 3.50017 14.665 3.5H6.335C6.00943 3.50017 5.69036 3.59116 5.41366 3.76274C5.13697 3.93432 4.91363 4.17969 4.76875 4.47125V4.47125Z"
      stroke="#404A57"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "IconDevices",
};
</script>

<style></style>
